module.exports = __webpack_public_path__ + "img/consultant_verify_cer.7620893d.png";